// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_Jy","legend":"e_Ky","legendContent":"e_Ly","contentWrapper":"e_My","fieldsetContent":"e_Ny"};